import { API_BASE } from "../auth/authApi";

export type ContentType = "tools" | "interactives";

export async function recordContentVisit(
  type: ContentType,
  name: string,
  sessionId: string
): Promise<void> {
  const response = await fetch(
    `${API_BASE}/api/content/${type}/${encodeURIComponent(name)}/visit`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ sessionId })
    }
  );
  if (!response.ok)
    throw new Error(`Failed to record content visit (${response.status})`);
}
